import { Grid2 } from "@mui/material";
import { useParams } from "react-router-dom";
import { AccountsAverageRateBlock, AccountsDiscoveryRate, GapsBlock } from "..";
import { useGetAnalyticsQuery } from "../../../../api";
import { useDebounceValue, useStateWithSearchParams } from "../../../../hooks";
import { IndicatorTimeframe, Order } from "../../../../types";
import { CustomLoader } from "../../../ui/CustomLoader";
import { useState } from "react";
import { ButtonTabs } from "../../../ui";
import { QUERY_SEPARATOR } from "../../../../constant";

type SearchParams = {
  sizes?: string;
  industries?: string;
  regions?: string;
  search?: string;
  sort?: string;
  page?: string;
  per_page?: string;
  selected?: string;
  limit?: string;
  date?: string;
  period?: string;
};

const roleTabs = ["Buying Committee", "Buying Cluster"];
const initialTab = roleTabs[0];

export const AccountsAnalyticBlock = ({ tabs }: { tabs?: string }) => {
  const { campaign_id } = useParams();
  const [currentTab, setCurrentTab] = useState(initialTab);

  const { searchDict } = useStateWithSearchParams<SearchParams>({
    industries: undefined,
    regions: undefined,
    sizes: undefined,
    search: undefined,
    page: undefined,
    per_page: undefined,
    selected: undefined,
    limit: undefined,
    date: undefined,
    period: undefined,
  });

  const searchValueDebounce = useDebounceValue(searchDict.search || "");

  const { data, isLoading } = useGetAnalyticsQuery(
    {
      campaign_id: campaign_id!,
      limit: searchDict.limit ? Number(searchDict?.limit) : undefined,
      size: searchDict.sizes?.split(QUERY_SEPARATOR),
      search: searchValueDebounce || undefined,
      industry: searchDict.industries?.split(QUERY_SEPARATOR),
      region: searchDict.regions?.split(QUERY_SEPARATOR),
      sort: tabs,
      order: searchDict.sort?.split("-")[1] as Order,
      start_date: searchDict.date?.split(QUERY_SEPARATOR)[0],
      end_date: searchDict.date?.split(QUERY_SEPARATOR)[1],
      indicator_timeframe: searchDict.period
        ? (searchDict.period.split(" ")[1].toLowerCase() as IndicatorTimeframe)
        : undefined,
    },
    { skip: !campaign_id, refetchOnMountOrArgChange: true },
  );

  if (isLoading || !data) return <CustomLoader />;

  const rateData =
    currentTab === initialTab
      ? data.committee_discovery
      : data.cluster_discovery;

  return (
    <Grid2 container spacing={3}>
      <Grid2 size={{ xs: 12, md: 5.6 }} sx={{ display: "flex" }}>
        <AccountsDiscoveryRate {...rateData}>
          <ButtonTabs
            currentTab={currentTab}
            onChange={setCurrentTab}
            tabList={roleTabs}
          />
        </AccountsDiscoveryRate>
      </Grid2>
      <Grid2 size={{ xs: 12, md: 4.2 }} sx={{ display: "flex" }}>
        <GapsBlock
          titleGaps={[
            ...data.title_gaps.high_impact,
            ...data.title_gaps.low_representation,
          ]}
        />
      </Grid2>
      <Grid2 size={{ xs: 12, md: 2.2 }} sx={{ display: "flex" }}>
        <AccountsAverageRateBlock analytics={data} campaign_id={campaign_id!} />
      </Grid2>
    </Grid2>
  );
};
